package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Zambia Flag (20x15dp)
 *
 * - ISO Alpha-2: ZM
 * - ISO Alpha-3: ZMB
 * - ISO Numeric: 894
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Zambia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Zambia:ZM:ZMB:894:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFF8126))) {
                moveTo(16.25f, 6.25f)
                horizontalLineToRelative(3.75f)
                verticalLineToRelative(8.75f)
                horizontalLineToRelative(-3.75f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(12.5f, 6.25f)
                horizontalLineToRelative(3.75f)
                verticalLineToRelative(8.75f)
                horizontalLineToRelative(-3.75f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(8.75f, 6.25f)
                horizontalLineToRelative(3.75f)
                verticalLineToRelative(8.75f)
                horizontalLineToRelative(-3.75f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF8126)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.509f, 1.948f)
                curveTo(13.848f, 2.072f, 13.509f, 2.263f, 13.509f, 2.263f)
                curveTo(13.509f, 2.263f, 13.443f, 2.185f, 13.443f, 2.12f)
                curveTo(13.443f, 2.056f, 13.184f, 2.12f, 13.05f, 2.356f)
                curveTo(12.923f, 2.579f, 13.157f, 2.578f, 13.402f, 2.577f)
                curveTo(13.416f, 2.577f, 13.429f, 2.577f, 13.443f, 2.577f)
                curveTo(13.581f, 2.577f, 13.798f, 2.564f, 14f, 2.551f)
                curveTo(14.175f, 2.54f, 14.339f, 2.53f, 14.43f, 2.53f)
                curveTo(14.626f, 2.53f, 14.719f, 2.53f, 14.977f, 2.356f)
                curveTo(15.145f, 2.243f, 15.7f, 2.104f, 16.113f, 2.001f)
                curveTo(16.336f, 1.946f, 16.517f, 1.901f, 16.574f, 1.876f)
                curveTo(16.737f, 1.803f, 16.411f, 2.185f, 16.411f, 2.185f)
                curveTo(16.411f, 2.185f, 17.668f, 1.678f, 17.92f, 1.505f)
                curveTo(18.076f, 1.398f, 18.005f, 1.489f, 17.89f, 1.638f)
                curveTo(17.819f, 1.731f, 17.731f, 1.845f, 17.668f, 1.948f)
                curveTo(17.562f, 2.124f, 17.778f, 1.956f, 18.019f, 1.77f)
                curveTo(18.148f, 1.67f, 18.284f, 1.565f, 18.38f, 1.505f)
                curveTo(18.657f, 1.332f, 18.31f, 1.801f, 18.157f, 1.948f)
                curveTo(18.004f, 2.095f, 18.516f, 1.948f, 18.693f, 1.801f)
                curveTo(18.823f, 1.694f, 18.704f, 1.882f, 18.604f, 2.041f)
                curveTo(18.568f, 2.098f, 18.534f, 2.151f, 18.516f, 2.185f)
                lineTo(18.513f, 2.191f)
                curveTo(18.444f, 2.316f, 18.423f, 2.356f, 18.587f, 2.356f)
                curveTo(18.753f, 2.356f, 18.157f, 2.819f, 18.157f, 2.819f)
                curveTo(18.157f, 2.819f, 18.335f, 2.791f, 18.157f, 3.099f)
                curveTo(18.052f, 3.281f, 17.543f, 3.464f, 17.129f, 3.614f)
                curveTo(16.841f, 3.717f, 16.6f, 3.804f, 16.574f, 3.863f)
                curveTo(16.527f, 3.967f, 16.063f, 4.087f, 15.847f, 4.144f)
                curveTo(15.77f, 4.164f, 15.724f, 4.176f, 15.74f, 4.176f)
                curveTo(15.801f, 4.176f, 15.903f, 4.253f, 15.793f, 4.253f)
                curveTo(15.682f, 4.253f, 15.489f, 4.315f, 15.489f, 4.315f)
                curveTo(15.489f, 4.315f, 15.591f, 4.315f, 15.489f, 4.46f)
                curveTo(15.44f, 4.53f, 15.355f, 4.519f, 15.295f, 4.511f)
                curveTo(15.229f, 4.503f, 15.194f, 4.498f, 15.27f, 4.605f)
                curveTo(15.337f, 4.702f, 15.362f, 4.737f, 15.355f, 4.747f)
                curveTo(15.346f, 4.759f, 15.295f, 4.738f, 15.216f, 4.738f)
                curveTo(15.146f, 4.738f, 15.071f, 4.708f, 14.992f, 4.677f)
                curveTo(14.905f, 4.642f, 14.814f, 4.605f, 14.719f, 4.605f)
                curveTo(14.546f, 4.605f, 14.719f, 4.728f, 14.828f, 4.805f)
                curveTo(14.833f, 4.808f, 14.837f, 4.811f, 14.841f, 4.814f)
                curveTo(14.938f, 4.883f, 14.898f, 4.882f, 14.722f, 4.882f)
                curveTo(14.705f, 4.882f, 14.686f, 4.882f, 14.665f, 4.882f)
                curveTo(14.556f, 4.882f, 14.498f, 4.87f, 14.466f, 4.863f)
                curveTo(14.433f, 4.857f, 14.43f, 4.856f, 14.43f, 4.882f)
                curveTo(14.43f, 4.906f, 14.348f, 4.872f, 14.25f, 4.831f)
                curveTo(14.147f, 4.788f, 14.027f, 4.738f, 13.962f, 4.738f)
                curveTo(13.833f, 4.738f, 14.234f, 5.004f, 14.234f, 5.004f)
                curveTo(14.234f, 5.004f, 14.026f, 4.936f, 13.912f, 4.882f)
                curveTo(13.848f, 4.851f, 13.93f, 4.997f, 14.004f, 5.129f)
                curveTo(14.06f, 5.229f, 14.111f, 5.321f, 14.09f, 5.321f)
                curveTo(14.075f, 5.321f, 14.04f, 5.304f, 14.001f, 5.285f)
                curveTo(13.921f, 5.247f, 13.82f, 5.198f, 13.82f, 5.263f)
                curveTo(13.82f, 5.359f, 13.912f, 5.431f, 14.026f, 5.431f)
                curveTo(14.139f, 5.431f, 14.157f, 5.582f, 14.09f, 5.582f)
                curveTo(14.067f, 5.582f, 14.039f, 5.572f, 14.011f, 5.562f)
                curveTo(13.96f, 5.544f, 13.912f, 5.527f, 13.912f, 5.582f)
                curveTo(13.912f, 5.616f, 13.932f, 5.643f, 13.956f, 5.673f)
                curveTo(13.988f, 5.714f, 14.026f, 5.764f, 14.026f, 5.854f)
                curveTo(14.026f, 6.01f, 13.857f, 6.032f, 13.912f, 5.929f)
                curveTo(13.968f, 5.825f, 13.721f, 5.576f, 13.721f, 5.698f)
                verticalLineTo(5.854f)
                curveTo(13.721f, 5.964f, 13.699f, 5.972f, 13.666f, 5.983f)
                curveTo(13.646f, 5.989f, 13.621f, 5.998f, 13.593f, 6.032f)
                curveTo(13.552f, 6.084f, 13.546f, 6.114f, 13.543f, 6.131f)
                curveTo(13.54f, 6.147f, 13.539f, 6.151f, 13.509f, 6.151f)
                curveTo(13.486f, 6.151f, 13.467f, 6.116f, 13.441f, 6.07f)
                curveTo(13.401f, 5.999f, 13.346f, 5.899f, 13.237f, 5.854f)
                curveTo(13.133f, 5.811f, 13.128f, 5.842f, 13.118f, 5.896f)
                curveTo(13.111f, 5.936f, 13.102f, 5.988f, 13.05f, 6.032f)
                curveTo(12.971f, 6.099f, 12.993f, 6.126f, 13.019f, 6.159f)
                curveTo(13.034f, 6.177f, 13.05f, 6.198f, 13.05f, 6.228f)
                curveTo(13.05f, 6.311f, 12.912f, 6.145f, 12.912f, 6.032f)
                curveTo(12.912f, 5.92f, 12.755f, 5.771f, 12.755f, 5.854f)
                curveTo(12.755f, 5.937f, 12.755f, 6.032f, 12.675f, 6.032f)
                curveTo(12.636f, 6.032f, 12.634f, 6.06f, 12.633f, 6.097f)
                curveTo(12.63f, 6.137f, 12.628f, 6.188f, 12.577f, 6.228f)
                curveTo(12.528f, 6.266f, 12.528f, 6.246f, 12.531f, 6.2f)
                curveTo(12.533f, 6.157f, 12.537f, 6.091f, 12.498f, 6.032f)
                curveTo(12.449f, 5.959f, 12.49f, 5.847f, 12.511f, 5.789f)
                curveTo(12.524f, 5.753f, 12.529f, 5.739f, 12.498f, 5.771f)
                curveTo(12.42f, 5.854f, 12.32f, 5.854f, 12.252f, 5.854f)
                horizontalLineTo(12.25f)
                curveTo(12.216f, 5.854f, 12.186f, 5.897f, 12.165f, 5.928f)
                curveTo(12.144f, 5.958f, 12.132f, 5.977f, 12.132f, 5.929f)
                curveTo(12.132f, 5.833f, 12.232f, 5.582f, 12.42f, 5.582f)
                curveTo(12.565f, 5.582f, 12.638f, 5.523f, 12.7f, 5.472f)
                curveTo(12.719f, 5.457f, 12.737f, 5.443f, 12.755f, 5.431f)
                curveTo(12.836f, 5.38f, 12.755f, 5.312f, 12.675f, 5.263f)
                curveTo(12.638f, 5.241f, 12.651f, 5.168f, 12.677f, 5.103f)
                curveTo(12.722f, 5.075f, 12.755f, 5.039f, 12.755f, 5.004f)
                curveTo(12.755f, 4.959f, 12.707f, 5.026f, 12.677f, 5.103f)
                curveTo(12.619f, 5.141f, 12.543f, 5.167f, 12.498f, 5.167f)
                curveTo(12.455f, 5.167f, 12.482f, 5.089f, 12.516f, 4.992f)
                curveTo(12.544f, 4.91f, 12.577f, 4.813f, 12.577f, 4.738f)
                curveTo(12.577f, 4.667f, 12.589f, 4.605f, 12.597f, 4.562f)
                curveTo(12.608f, 4.507f, 12.613f, 4.483f, 12.577f, 4.513f)
                curveTo(12.534f, 4.55f, 12.301f, 4.509f, 12.142f, 4.482f)
                curveTo(12.074f, 4.47f, 12.019f, 4.46f, 11.999f, 4.46f)
                curveTo(11.969f, 4.46f, 11.993f, 4.404f, 12.017f, 4.349f)
                curveTo(12.047f, 4.279f, 12.077f, 4.21f, 11.999f, 4.253f)
                curveTo(11.877f, 4.32f, 11.63f, 4.317f, 11.474f, 4.316f)
                curveTo(11.451f, 4.315f, 11.43f, 4.315f, 11.412f, 4.315f)
                curveTo(11.32f, 4.315f, 11.383f, 4.234f, 11.417f, 4.191f)
                curveTo(11.436f, 4.166f, 11.446f, 4.154f, 11.412f, 4.176f)
                curveTo(11.318f, 4.235f, 11.226f, 4.253f, 11.12f, 4.253f)
                curveTo(11.073f, 4.253f, 11.06f, 4.225f, 11.045f, 4.194f)
                curveTo(11.027f, 4.157f, 11.007f, 4.115f, 10.922f, 4.116f)
                curveTo(10.766f, 4.117f, 10.731f, 4.115f, 10.646f, 4.047f)
                curveTo(10.601f, 4.012f, 10.626f, 3.991f, 10.64f, 3.98f)
                curveTo(10.653f, 3.969f, 10.657f, 3.966f, 10.589f, 3.966f)
                horizontalLineTo(10.168f)
                curveTo(9.958f, 3.966f, 10.169f, 3.802f, 10.244f, 3.802f)
                curveTo(10.32f, 3.802f, 10.408f, 3.655f, 10.244f, 3.721f)
                curveTo(10.14f, 3.763f, 10.028f, 3.752f, 9.895f, 3.738f)
                curveTo(9.821f, 3.73f, 9.74f, 3.721f, 9.651f, 3.721f)
                curveTo(9.402f, 3.721f, 9.354f, 3.606f, 9.501f, 3.606f)
                curveTo(9.648f, 3.606f, 9.657f, 3.522f, 9.428f, 3.522f)
                curveTo(9.285f, 3.522f, 9.166f, 3.483f, 9.078f, 3.454f)
                curveTo(9.026f, 3.436f, 8.985f, 3.423f, 8.954f, 3.423f)
                curveTo(8.874f, 3.423f, 8.786f, 3.309f, 8.954f, 3.309f)
                curveTo(9.123f, 3.309f, 9.338f, 3.215f, 9.154f, 3.215f)
                curveTo(9.05f, 3.215f, 8.877f, 3.159f, 8.726f, 3.111f)
                curveTo(8.61f, 3.074f, 8.507f, 3.041f, 8.46f, 3.041f)
                curveTo(8.423f, 3.041f, 8.48f, 3.029f, 8.556f, 3.013f)
                curveTo(8.708f, 2.98f, 8.934f, 2.932f, 8.645f, 2.932f)
                curveTo(8.337f, 2.932f, 8.013f, 2.68f, 7.79f, 2.507f)
                curveTo(7.699f, 2.436f, 7.625f, 2.378f, 7.575f, 2.356f)
                curveTo(7.402f, 2.277f, 7.575f, 2.12f, 7.625f, 2.185f)
                curveTo(7.675f, 2.25f, 8.024f, 2.35f, 7.873f, 2.263f)
                curveTo(7.722f, 2.176f, 7.625f, 2.028f, 7.575f, 1.948f)
                curveTo(7.525f, 1.868f, 7.564f, 1.813f, 7.625f, 1.876f)
                curveTo(7.686f, 1.939f, 7.97f, 2.12f, 7.97f, 2.12f)
                curveTo(7.97f, 2.12f, 7.818f, 1.948f, 7.698f, 1.678f)
                curveTo(7.578f, 1.408f, 7.818f, 1.474f, 8.024f, 1.678f)
                curveTo(8.23f, 1.882f, 8.424f, 1.936f, 8.521f, 1.948f)
                curveTo(8.618f, 1.96f, 8.424f, 1.801f, 8.237f, 1.678f)
                curveTo(8.05f, 1.555f, 8.093f, 1.115f, 8.237f, 1.291f)
                curveTo(8.312f, 1.382f, 8.668f, 1.556f, 9.016f, 1.727f)
                curveTo(9.337f, 1.884f, 9.651f, 2.038f, 9.733f, 2.12f)
                curveTo(9.874f, 2.263f, 9.76f, 2.05f, 9.638f, 1.819f)
                curveTo(9.612f, 1.772f, 9.587f, 1.724f, 9.563f, 1.678f)
                curveTo(9.482f, 1.521f, 9.809f, 1.699f, 10.182f, 1.902f)
                curveTo(10.45f, 2.048f, 10.742f, 2.207f, 10.922f, 2.263f)
                curveTo(11.045f, 2.301f, 11.192f, 2.362f, 11.34f, 2.424f)
                curveTo(11.703f, 2.575f, 12.066f, 2.725f, 12.066f, 2.53f)
                curveTo(12.066f, 2.254f, 12.399f, 1.824f, 12.755f, 1.678f)
                curveTo(12.982f, 1.586f, 13.088f, 1.669f, 13.222f, 1.774f)
                curveTo(13.3f, 1.835f, 13.386f, 1.903f, 13.509f, 1.948f)
                close()
                moveTo(13.126f, 5.178f)
                curveTo(13.206f, 5.178f, 13.184f, 4.342f, 13.184f, 4.342f)
                curveTo(13.184f, 4.342f, 13.422f, 4.855f, 13.422f, 5.077f)
                curveTo(13.422f, 5.178f, 13.415f, 5.208f, 13.417f, 5.237f)
                curveTo(13.42f, 5.272f, 13.436f, 5.306f, 13.493f, 5.457f)
                curveTo(13.552f, 5.612f, 13.513f, 5.595f, 13.407f, 5.549f)
                curveTo(13.322f, 5.513f, 13.193f, 5.457f, 13.037f, 5.457f)
                curveTo(12.687f, 5.457f, 13.045f, 5.178f, 13.126f, 5.178f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun ZambiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Zambia,
            contentDescription = "Zambia Flag"
        )
    }
}
